<template>
    <project-step-container
            prev-to="js_deep_customer_empathy_4"
            :on-discard-project="redirection"
            :on-keep-version-project="redirection"
            @next-click="updateProject"
    >
        <b-row class="first-form">
            <b-col cols="12" class="mb-3 simple-text" tabindex="0">
                {{getMessage(5, 'empathy-map-sub')}}
            </b-col>
        </b-row>
        <LinkStyleGuide @open-url="openGuide" icon-name="icon-guide" :text="getMessage(5, 'empathy-map-guide')" ></LinkStyleGuide>

        <b-row class="mt-3 text-center">
            <b-col :key="index" v-for="(emotion, index) in Emotions" cols="6" class="emotion-content pr-2">
                <b-button block size="lg" class="square" :class="{active: form.emotion.key === emotion.key, isCareerEntrep: isJACareerEntrepreApp}"
                          v-on:click="select(emotion)">
                    <span>{{emotion.value}}</span>
                </b-button>
            </b-col>
        </b-row>
        <b-row class="mt-3">
            <b-col cols="12" class="mt-3" v-if="showOther">
                <label for="other-emotion" class="other-emotion">{{getMessage(5, 'otherEmotion')}}</label>
                <input id="other-emotion" type="text" v-model="form.otherEmotion"/>
            </b-col>
        </b-row>
        <project-style-guide :style-guide="styleGuide"/>
    </project-step-container>
</template>

<script>
    import {Storage, Project, ConflictSyn, StyleGuides} from "../../../core/Utils"
    import Steps from "../Utils/steps";
    import ProjectStepContainer from "../../../core/Components/ProjectStepContainer"
    import LinkStyleGuide from "../../../core/Components/LinkStyleGuide"
    import ProjectStyleGuide from "../../../core/Components/ProjectStyleGuide";

    const EmotionsTypes = {
        FRUSTRATED : 1,
        WORRIED : 2,
        STRESSED : 3,
        IRRITATED : 4,
        CONFUSED : 5,
        AFRAID : 6,
        SAD : 7,
        OTHER : 8,
    }

    const Emotions = Object.freeze([
        {key: EmotionsTypes.FRUSTRATED, value: "Frustrated"},
        {key: EmotionsTypes.WORRIED, value: "Worried"},
        {key: EmotionsTypes.STRESSED, value: "Stressed"},
        {key: EmotionsTypes.IRRITATED, value: "Irritated"},
        {key: EmotionsTypes.CONFUSED, value: "Confused"},
        {key: EmotionsTypes.AFRAID, value: "Afraid"},
        {key: EmotionsTypes.SAD, value: "Sad"},
        {key: EmotionsTypes.OTHER, value: "Other"},
    ])

    export default {
        name: "DeepCustomerEmpathy5",
        components: {ProjectStepContainer,LinkStyleGuide , ProjectStyleGuide},
        data() {
            return {
                step: Steps.FORM_EMOTION,
                urlNextProject:'js_deep_customer_empathy_6',
                styleGuide: StyleGuides.getStyleGuide(StyleGuides.FOLLOW_ME_HOME_GUIDE),
                form: {
                    emotion: {},
                    otherEmotion: ""
                },
                showOther: false
            }
        },
        created() {
            this.Emotions = Emotions
        },
        mounted() {
            const forms = Storage.getProjectForms(this.$route.params.index)
            if (this.step in forms) this.form = forms[this.step]
            this.showOther = this.form.emotion.key === EmotionsTypes.OTHER
        },
        methods: {
            openGuide() {
                this.$bvModal.show('project-style-guide')
            },
            select(emotion) {
                this.form.emotion = emotion
                this.showOther = emotion.key === EmotionsTypes.OTHER
            },
            updateProject() {
                const stepNumber = Steps.getStepFromForm(this.step)
                const index = this.$route.params.index
                Project.saveProjectStep(index, this.step, stepNumber, this.form, this.isOffline, this.isGuest).then(response => {
                    if (response.project?.hasDifferenceVersion) {
                        ConflictSyn.show(response.index, response.project)
                    } else {
                        this.redirection()
                    }
                }).catch(err => {
                    this.redirection()
                })
            },
            redirection() {
                const index = this.$route.params.index
                this.$router.push({name: this.urlNextProject, params: {index}})
            }
        }
    }
</script>

<style lang="stylus" scoped>
    @import "~@/core/Styles/variables.styl"
    @import "~@/core/Styles/mixins.styl"
    @media (max-width: 320px)
        .font-size
            .emotion-content
                padding-right: 2px !important
                padding-left: 2px !important

    .font-size
        .square
           word-break break-all
           padding-right: 0px;
           padding-left: 0px;

    .high-contrast
        .square
            border 1px solid  color-4
            box-shadow(0px 1px 5px color-16)
            color black
            &:hover
                border solid 1px color-29

            &.active
                background-color color-29
                color white
    .other-emotion
        font font-sourcesans-bold
        font-size 14px
        color black

    .square
        font-family 'Source Sans Pro', sans-serif
        font-size 16px
        font-weight 400
        color color-4
        border-radius 10px
        box-shadow(0px 1px 5px color-16)
        height 69px
        margin-top 15px

        &:hover
            border solid 1px color-5

        &.active
            background-color color-5
            color white

    .table-t
        display table
        height 69px
        width 100%

    .text-t
        display table-cell
        vertical-align middle
</style>
